export default __webpack_public_path__ + "static/media/Manage money-pana.01b5db85.svg";